import * as pbi from "powerbi-client";
import * as pbiModels from "powerbi-models";
const elementResizeEvent = require("element-resize-event");
export default {
  props: {
    pageName: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default() {
        return [];
      }
    },
    heightRatio: {
      type: Number,
      default: 0.6
    }
  },
  data() {
    return {
      report: null,
      powerbi: null
    };
  },
  mounted() {
    this.setContainerHeight();
    this.powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    let context = this;
    elementResizeEvent(this.$refs.container, context.setContainerHeight);
    if (this.$store.state.embeddedConfig.id) this.embed();
  },
  watch: {
    "$store.state.embeddedConfig"() {
      this.embed();
    },
    filters() {
      this.setFilters();
    },
    pageName(val) {
      this.report.setPage(val);
    }
  },
  methods: {
    setContainerHeight() {
      this.$refs.container.style.height = this.$refs.container.offsetWidth * this.heightRatio + "px";
    },
    setFilters() {
      if (this.report) this.report.setFilters(this.filters);
    },
    embed() {
      // eslint-disable-next-line no-undef
      this.report = this.powerbi.embed(this.$refs.container, {
        type: "report",
        pageName: this.pageName,
        filters: this.filters,
        id: this.$store.state.embeddedConfig.id,
        embedUrl: this.$store.state.embeddedConfig.embedUrl,
        tokenType: pbiModels.TokenType.Embed,
        accessToken: this.$store.state.embeddedConfig.accessToken,
        settings: {
          panes: {
            bookmarks: {
              visible: false
            },
            fields: {
              visible: false
            },
            filters: {
              visible: false
            },
            pageNavigation: {
              visible: false
            },
            selection: {
              visible: false
            },
            syncSlicers: {
              visible: false
            }
          }
        }
      });
    }
  }
};